import { Input } from 'antd';
import { debounce } from 'lodash';
import { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { Wrapper } from './QuizSearch.styles';

import { useMyQuizzesList } from '@/store';

type Props = {
  maxWidth?: number;
};

export const QuizSearch: FC<Props> = ({ maxWidth }) => {
  const { setSearch, isLoading } = useMyQuizzesList();
  const { t } = useTranslation('ManagerQuizzesTranslations');

  const resetSearch = () => setSearch('');

  const handleQuizSearch = async (value: string) => {
    if (value === '') resetSearch();
    if (value.length < 2) {
      return;
    }
    setSearch(value);
  };

  const handleSearch = debounce(handleQuizSearch, 500);

  useEffect(() => {
    return () => {
      resetSearch();
    };
  }, []);

  return (
    <Wrapper maxWidth={maxWidth}>
      <Input.Search
        allowClear
        loading={isLoading}
        onChange={e => handleSearch(e.target.value)}
        placeholder={t('SEARCH_PLACEHOLDER')}
      />
    </Wrapper>
  );
};
